export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-06-13 at 22.28.59 (1).f052577d.jpeg";